
export default {
  setMe: (state, me) => {
    state.me = me;
  },
  setLogged: (state, logged) => state.logged = logged,
  setTipoArchivos(state, update) {
    state.tipoArchivos = update;
  },
  setUsuario(state, usuario) {
    state.usuario = usuario;
  },
};
